module.exports = __webpack_public_path__ + "img/QRCodeProduct.c35d2be0.png";